import React from 'react'
import { FormattedMessage } from 'react-intl'

import { useVatStatus } from './useVatStatus'
import { VAT_STATUS } from '../price-context/VAT_STATUS'
import { toggleColorEnum } from '../../atoms/fields/toggle-button/toggleColorEnum'
import Toggle from '../../atoms/toggle/Toggle'

const ToggleVatStatus = () => {
  const { vatStatus, setVatStatus } = useVatStatus()
  return (
    <Toggle
      nameLeft={
        <FormattedMessage
          id='ui.ModalSelectProposalFooter.exclVat'
          defaultMessage='HT'
        />
      }
      nameRight={
        <FormattedMessage
          id='ui.ModalSelectProposalFooter.inclVat'
          defaultMessage='TTC'
        />
      }
      value={vatStatus === VAT_STATUS.HT}
      setValue={(value) => setVatStatus(value ? VAT_STATUS.HT : VAT_STATUS.TTC)}
      toggleColor={toggleColorEnum.BLACK}
    />
  )
}

export default ToggleVatStatus
